namespace $.$$ {

	export class $shm_hitalama_map_widget_panel extends $.$shm_hitalama_map_widget_panel {

		panel_size(): { width: number, height: number } {
			const rect = this.Panel_body().dom_node_actual().getBoundingClientRect()
			const zoom = this.zoom() || 1

			return {
				width: Math.ceil( rect.width / zoom ),
				height: Math.ceil( rect.height / zoom ),
			}
		}

		size_sync() {
			const size = this.panel_size()

			if( size.width > 0 && this.widget().right_edge_x() !== size.width ) {
				this.widget().right_edge_x( size.width )
			}

			if( size.height > 0 && this.widget().bottom_edge_y() !== size.height ) {
				this.widget().bottom_edge_y( size.height )
			}

			return null
		}

	}

}
